var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3C2.5 1.89543 3.39543 1 4.5 1H16.5C17.6046 1 18.5 1.89543 18.5 3V15C18.5 16.1046 17.6046 17 16.5 17H4.5C3.39543 17 2.5 16.1046 2.5 15V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5C4.5 3.89543 5.39543 3 6.5 3H14.5C15.6046 3 16.5 3.89543 16.5 5V13C16.5 14.1046 15.6046 15 14.5 15H6.5C5.39543 15 4.5 14.1046 4.5 13V5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9C11.5 9.55228 11.0523 10 10.5 10C9.94772 10 9.5 9.55228 9.5 9C9.5 8.44772 9.94772 8 10.5 8C11.0523 8 11.5 8.44772 11.5 9Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 9C15.5 11.7614 13.2614 14 10.5 14C7.73858 14 5.5 11.7614 5.5 9C5.5 6.23858 7.73858 4 10.5 4C13.2614 4 15.5 6.23858 15.5 9ZM10.5 11.5C11.8807 11.5 13 10.3807 13 9C13 7.61929 11.8807 6.5 10.5 6.5C9.11929 6.5 8 7.61929 8 9C8 10.3807 9.11929 11.5 10.5 11.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18H9.5L8.64843 19.2774C8.5557 19.4164 8.39958 19.5 8.23241 19.5H5.76759C5.60042 19.5 5.4443 19.4164 5.35157 19.2774L4.5 18Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18H16.5L15.6484 19.2774C15.5557 19.4164 15.3996 19.5 15.2324 19.5H12.7676C12.6004 19.5 12.4443 19.4164 12.3516 19.2774L11.5 18Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVault);
export default __webpack_public_path__ + "static/media/icon-vault.54d0a7ec0212fffabc59ca256c283821.svg";
export { ForwardRef as ReactComponent };